import * as tslib_1 from "tslib";
import leftNavGroupsStore from '../store/store';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import { shallowCompare } from 'office-ui-fabric-react/lib/Utilities';
import TreeNode from 'owa-tree-node/lib/components/TreeNode';
import * as React from 'react';
// Mobx does not support as of 8/29/2016 @computed in GroupNode,
// because it needs to be part of a view model class. This is our
// workaround in order to use computed properties.
var GroupNodeComputedState = /** @class */ (function () {
    function GroupNodeComputedState(props) {
        this.props = props;
    }
    Object.defineProperty(GroupNodeComputedState.prototype, "isSelected", {
        get: function () {
            return this.props.isSelected(this.props.groupId, this.props.customData);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GroupNodeComputedState.prototype, "isWithContextMenuOpen", {
        get: function () {
            return (leftNavGroupsStore.withContextMenuGroup &&
                this.props.groupId == leftNavGroupsStore.withContextMenuGroup.groupId);
        },
        enumerable: true,
        configurable: true
    });
    tslib_1.__decorate([
        computed
    ], GroupNodeComputedState.prototype, "isSelected", null);
    tslib_1.__decorate([
        computed
    ], GroupNodeComputedState.prototype, "isWithContextMenuOpen", null);
    return GroupNodeComputedState;
}());
var GroupNode = /** @class */ (function (_super) {
    tslib_1.__extends(GroupNode, _super);
    function GroupNode(props) {
        var _this = _super.call(this, props) || this;
        _this.onClick = function (evt) {
            evt.stopPropagation();
            _this.props.selectGroup(_this.props.groupId, _this.props.customData);
        };
        _this.onKeyDown = function (evt) {
            switch (evt.keyCode) {
                case 13 /* Enter */:
                case 32 /* Space */:
                    evt.stopPropagation();
                    _this.props.selectGroup(_this.props.groupId, _this.props.customData);
                    break;
            }
        };
        _this.renderRightCharm = function () {
            return _this.props.renderRightCharm(_this.props.groupId, _this.props.customData);
        };
        _this.renderRightCharmHover = function () {
            return _this.props.renderRightCharmHover(_this.props.groupId, _this.props.customData);
        };
        _this.computedState = new GroupNodeComputedState(_this.props);
        return _this;
    }
    GroupNode.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        return !shallowCompare(this.props, nextProps);
    };
    GroupNode.prototype.render = function () {
        return (React.createElement(TreeNode, { chevronProps: this.props.chevronProps, customIcon: this.props.customIcon, depth: 1, displayName: this.props.displayName, isBeingDragged: this.props.isBeingDragged, isDroppedOver: this.props.isDroppedOver, isRootNode: false, isSelected: this.computedState.isSelected, isWithContextMenuOpen: this.computedState.isWithContextMenuOpen, key: this.props.groupId, onClick: this.onClick, onContextMenu: this.props.onContextMenu, onKeyDown: this.onKeyDown, renderCustomTreeNodeDisplay: this.props.renderCustomTreeNodeDisplay, renderRightCharm: this.renderRightCharm, renderRightCharmHover: this.renderRightCharmHover, showAsHoverOnDroppedOver: this.props.showHoverStateOnDroppedOver }));
    };
    GroupNode = tslib_1.__decorate([
        observer
    ], GroupNode);
    return GroupNode;
}(React.Component));
export default GroupNode;
//# sourceMappingURL=GroupNode.js.map